import {
  destDetailAtom,
  mapZoomLevelAtom,
  MARKER_VIEW_ZOOM,
  polyLineOverAtom,
  shippingCardOverAtom,
} from '@/commons/constants';
import { useAtom, useAtomValue, useSetAtom } from 'jotai';
import { useEffect, useState } from 'react';
import { Marker } from 'react-naver-maps';
import { tooltipAtom } from '.';
import { Dest, TimeLine, TimeLineItem } from '@/types/result';

export default function RoutingMarker({ list }: { list: TimeLine[] }) {
  const setTooltip = useSetAtom(tooltipAtom);

  const [polyLineOver, setPolyLineOver] = useAtom(polyLineOverAtom);
  const [destDetail, setDestDetail] = useAtom(destDetailAtom);

  const mapZoomLevel = useAtomValue(mapZoomLevelAtom);
  const shippingCardOver = useAtomValue(shippingCardOverAtom);

  const [highlightList, setHilightList] = useState<number[]>([]);

  useEffect(() => {
    //활성화(highlight) 대상 선정
    const temp: number[] = [];
    polyLineOver && temp.push(polyLineOver); //경로에 마우스 오버
    shippingCardOver && temp.push(shippingCardOver); //목록 마우스 오버
    setHilightList(temp);
  }, [polyLineOver, shippingCardOver]);

  const handleClick = (item: TimeLine, pItem: Dest) => {
    const targetShipping = list.find((lItem: TimeLine) => lItem.car.car_seq === item.car.car_seq);
    if (targetShipping) {
      const target = targetShipping.destList.find((dItem: Dest) => dItem.id === pItem.id);
      setDestDetail({ car: targetShipping.car, color: targetShipping.color, dest: target });
    }
  };

  const handleMouseOver = (item: TimeLine) => {
    setPolyLineOver(item.car.car_seq);
  };

  const handleMouseOut = () => {
    setTooltip(undefined);
    setPolyLineOver(undefined);
  };

  return (
    <>
      {list &&
        list.length > 0 &&
        list.map((carItem: TimeLine) =>
          carItem?.timelineList
            ?.filter((v) => v.target)
            ?.map((pItem: TimeLineItem, pIndex: number) => {
              //활성화 대상 체크
              const check =
                highlightList.length > 0 && highlightList.findIndex((fItem) => fItem === carItem.car.car_seq) > -1;
              //클릭한 대상체크(팝업에 표시하는 대상(목적지)은 더크게 표시함)
              const selected = destDetail?.dest.id === pItem.target.id ? true : false;
              return (
                (mapZoomLevel > MARKER_VIEW_ZOOM || pIndex === 0 || list.length === 1 || check) && (
                  <Marker
                    key={pIndex}
                    zIndex={100 + (selected ? pIndex : 0)}
                    icon={{
                      content: `<div style='display:flex;opacity:${highlightList.length == 0 || check ? 1 : 0.4};${selected ? 'font-weight:800;font-size:1rem;' : ''}width:${selected ? 1 : 0.8}rem;height:${selected ? 1 : 0.8}rem;justify-content:center;align-items:center;border-radius:25px;padding:0.25rem;background:${pItem.color};color:#ffffff'>${pItem.target.delivery_no}</div>`,
                    }}
                    position={pItem.target.coord ?? undefined}
                    onClick={() => handleClick(carItem, pItem.target)}
                    onMouseover={() => handleMouseOver(carItem)}
                    onMouseout={handleMouseOut}
                  />
                )
              );
            }),
        )}
    </>
  );
}
